const NAV_COLLAPSED_KEY = "navCollapsed";

export const getNavCollapsed = () => {
    if (typeof window === "undefined") {
        return false;
    }
    return window.localStorage.getItem(NAV_COLLAPSED_KEY) === "true";
};

export const setNavCollapsed = (collapsed) => {
    if (typeof window === "undefined") {
        return;
    }
    window.localStorage.setItem(NAV_COLLAPSED_KEY, collapsed ? "true" : "false");
};
